import { useCardStatusStore } from "../stores/cardStatusStore";
import { CardStatus, UserCard } from "../api/types";

interface UseCardDataReturn {
  status: CardStatus | null;
  userCard: UserCard | null;
  isUserCardDelegated: boolean;
  isLoading: boolean;
  error: string | null;
  refreshCardStatus: () => Promise<void>;
}

export const useCardData = (): UseCardDataReturn => {
  const {
    status,
    userCard,
    isUserCardDelegated,
    isLoading,
    error,
    _refreshCardStatus,
  } = useCardStatusStore();

  return {
    status,
    userCard,
    isUserCardDelegated,
    isLoading,
    error,
    refreshCardStatus: _refreshCardStatus,
  };
};
